'use strict';

var React = require('react');
var styleHelper = require('../../helper/styleHelper');
var graphicsHelper = require('./../../helper/graphicsHelper');
var propConst = require('../../constants/propConst');

/**
 * 垂直分割条
 */
var VerticalRule = React.createClass({
    render: function () {
      var width = styleHelper.getWidth(this.props);
      var height = styleHelper.getHeight(this.props);
      return (
        <div>
          <canvas
            ref="canvas"
            style={{width:'100%',height:'100%'}}
            onChange={this.paint.bind(this, this.props)}
            width={width}
            height={height}/>
        </div>
      );
    },

  componentDidMount: function() {
    this.paint();
  },

  componentDidUpdate: function() {
    this.paint();
  },

  paint: function () {
    var canvas = ReactDOM.findDOMNode(this.refs.canvas);
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);
    var dashMode = styleHelper.parseDashMode(styleHelper.getPropertyValue(this.props, propConst.DASH_MODE));
    var lineWidth = styleHelper.getBorderWidth(this.props);
    var strokeColor = styleHelper.getBackgroundColor(this.props);
    var x = (parseInt(w/2, 10) || 6) - (lineWidth % 2 === 0 ? 0 : 0.5);
    var ctx = canvas.getContext('2d');

    var ratio = graphicsHelper.applyDeviceRatio(ctx,w,h);
    w *= ratio;
    h *= ratio;
    x *= ratio;
    lineWidth *= ratio;
    graphicsHelper.clearRect(ctx);
    //ctx.clearRect(0, 0, w, h);
    graphicsHelper.drawLine(ctx, {
      dashMode: dashMode,
      lineWidth: lineWidth,
      strokeColor: strokeColor,
      startX: x,
      startY: 0,
      endX: x,
      endY: h
    });

  },
});

module.exports = VerticalRule;



// WEBPACK FOOTER //
// ./src/views/Components/VRule.jsx